/**
 * 未设置列宽度下列最小宽度
 */
export const AUTOCELLWIDTH = 120;
